module.exports = __webpack_public_path__ + "static/img/icon11.7c3d97a0.png";